<template>

    <Container class="text-center w-full flex gap-y-4 justify-center items-center flex-col min-h-96">

        <h1 class="text-sn-orange text-5xl">{{ error?.statusCode }}</h1>

        <div v-if="error?.statusCode === 404">
            <h2 class="text-3xl mb-4">Page not found</h2>
            <p>Hmm. It would appear that the page you are trying to access doesn't exist.</p>
        </div>

        <div v-if="error?.statusCode === 403">
            <h2 class="text-3xl mb-4">Unauthorised</h2>
            <p>Sorry, but you are not authorised to do this action.</p>
        </div>

        <div v-if="error?.statusCode === 500">
            <h2 class="text-3xl mb-4">Server Error</h2>
            <p>Ah. It would appear that something has gone wrong.</p>
        </div>

        <NuxtLink to="/">Home</NuxtLink>

    </Container>

</template>

<script setup lang="ts">
    import type { NuxtError } from '#app'
    import Container from "@/components/core/Container.vue";

    const props = defineProps({
        error: Object as () => NuxtError
    })
</script>